/**
 * @description Document types that can be uploaded by user
 */
export enum DocType {
  BankStatements = 'BankStatements',
  PayStatements = 'PayStatements',
  LoanLetter = 'LoanLetter',
  OtherOfficialDoc = 'OtherOfficialDoc',
  ProvidentFundDoc = 'ProvidentFundDoc',
  Visa = 'Visa'
}

export enum DocUploadReason {
  TransactionOnHold = 'transactionOnHold',
  VisaUpload = 'visaUpload'
}

export enum DocUploadType {
  CopyOfVisa = 'CopyOfVisaDoc',
  ProofOriginOfMoney = "ProofOriginOfMoney"
}

export enum DocUploadStatus {
  Open = 'Open',
  Closed = 'Closed'
}

export interface DocUploadItem {
  title: string;
  subtitle: string;
  img: string;
  customId: string;
  action: (item: DocUploadItem) => void;
}


// WEBPACK FOOTER //
// ./src/model/types/doc-type.ts